'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.pbkdf2_hmac_sha256 = pbkdf2_hmac_sha256;

var _asmcryptoAll = require('asmcrypto.js/asmcrypto.all.js');

var asmcrypto = _interopRequireWildcard(_asmcryptoAll);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

/** HKDF with the specified hash function.
	 * @param {Uint8Array | String} password The input password
	 * @param {Uint8Array | String} salt The salt
	 * @param {Int} iteration Interations
	 * @param {Int} keyBitLength The desired key length
	 * @return {Uint8Array} derived key.
	 */
function pbkdf2_hmac_sha256(password, salt, iteration, keyBitLength) {
	return asmcrypto.PBKDF2_HMAC_SHA256.bytes(password, salt, iteration, keyBitLength / 8);
}

exports.default = pbkdf2_hmac_sha256;